import {Injectable} from '@angular/core';
import {StorageService} from './storage.service';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PottosService {
  constructor(private storageSvc: StorageService) {}

  initializePottos() {
    const rcid = this.storageSvc.getValue('cli_rcid');
    const cli_user_number = this.storageSvc.getValue('cli_number');

    if (!rcid || !cli_user_number) {
      return;
    }

    setTimeout(() => {
      this.loadPottosScript(rcid, cli_user_number);
    }, 0);
  }

  private loadPottosScript(rcid: string, cli_user_number: string) {
    (function (window: Window, document: Document, tagName: string, scriptId: string) {
      type PottosFunction = (...args: any[]) => void;
      interface WindowWithPottos extends Window {
        pottos?: PottosFunction & {q?: any[]; l?: number};
      }

      const w = window as WindowWithPottos;
      const d = document;
      const t = tagName;
      const s = scriptId;

      w[s] =
        w[s] ||
        function (...args: any[]) {
          (w[s]!.q = w[s]!.q || []).push(args);
        };

      w[s]!.l = new Date().getTime();

      const scriptElement = d.createElement(t) as HTMLScriptElement;
      const firstScript = d.getElementsByTagName(t)[0];

      scriptElement.async = true;
      scriptElement.src = 'https://embed.pottos.jp/embed.js';

      firstScript.parentNode!.insertBefore(scriptElement, firstScript);
    })(window, document, 'script', 'pottos');
    (window as any).pottos('init', environment.pottosTrackingToken, rcid, cli_user_number);
  }

  spaInit(url: string) {
    setTimeout(() => {
      const isPottosAvailable = window['pottos'];

      if (isPottosAvailable) {
        window['pottos']('spaInit');
      } else {
        console.log('pottos not found', 'isPottosAvailable:', isPottosAvailable);
      }
    }, 0);
  }
}
